<script setup lang="ts">
/**
 * Interim Dividends (B32113) — Directors' Resolutions in Writing (Interim Dividend).
 *   원본: Directors_ Resolution for Interim Dividends.docx — 문구가 주주구성과 무관(시나리오 분기 없음).
 *   서명 = 이사 전원([[Signers]]) → dr_Signers.
 *   입력 엔진(cdd)·서명 위젯은 Final Dividends 와 공유.
 */
import CddVarField from '../../final-dividends/cdd/CddVarField.vue';
import AgmSigners from '../../final-dividends/cdd/AgmSigners.vue';
import '../../final-dividends/docs/agmDoc.css';
</script>

<template>
  <div class="agm-doc">
    <div class="doc-head">
      <div><b><CddVarField field-key="company_name" label="Company Name" /></b></div>
      <div>Company Registration No. <CddVarField field-key="company_registration_no" label="Reg No" /></div>
      <div>(Incorporated in the Republic of Singapore)</div>
      <div>(the &ldquo;Company&rdquo;)</div>
    </div>

    <div class="doc-title">DIRECTORS&rsquo; RESOLUTIONS IN WRITING</div>
    <div class="doc-sub">PASSED PURSUANT TO THE COMPANY'S CONSTITUTION</div>

    <div class="sec-title" style="text-align:center">INTERIM DIVIDEND</div>
    <p class="doc-p"><b>NOTED:</b></p>
    <p class="doc-p">
      That the Company has sufficient profits for the declaration of interim dividend in respect of the financial year ending
      <CddVarField field-key="financial_year_end" label="Financial Year End" /> to the Company&rsquo;s members.
    </p>
    <p class="doc-p"><b>RESOLVED: -</b></p>
    <p class="doc-p">
      That a tax exempt (1-tier) interim dividend of <CddVarField field-key="dividend_amount" label="Dividend Amount" />
      be declared out of the profits of the Company for the financial year ending
      <CddVarField field-key="financial_year_end" label="Financial Year End" /> and that the said dividend be made payable on
      <CddVarField field-key="payment_date" label="Payment Date" /> to the members of the Company registered in the Register of
      Members as at the date hereof.
    </p>
    <p class="doc-p">
      THAT any one Director of the Company be hereby authorised to issue the dividend voucher relating to the aforementioned
      declaration of interim dividend.
    </p>

    <p class="doc-p">Dated: <CddVarField field-key="resolution_date" label="Resolution Date" /></p>

    <div class="sign-block">
      <AgmSigners var-key="dr_Signers" board-label="Director" />
    </div>
  </div>
</template>
